// App-side delegate for `@heidi/templates/data` (D2.7, ARCFE-1046).
// isAuthenticated and the desktop-readiness read cross as booleans
// (cohort-C) and the error toast stayed; the two chained sorts, the offline
// cache fallback and the module-scope invalidator moved with the body.
import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import { toast } from '@heidi/design-system/toast';
import { GET_DOCUMENT_TEMPLATES } from '@heidi/templates/contracts';
import {
  invalidateDocumentTemplates,
  useQueryDocumentTemplates as useQueryDocumentTemplatesCore,
} from '@heidi/templates/data';
import type { AxiosError } from 'axios';
import { useCallback } from 'react';
import { useIsDesktopOnlineReady } from '../desktop/useIsDesktopOnlineReady';

export { GET_DOCUMENT_TEMPLATES, invalidateDocumentTemplates };

export function useQueryDocumentTemplates(enabled = true) {
  const { isAuthenticated } = useIsAuthenticated();
  const isDesktopOnlineReady = useIsDesktopOnlineReady();

  const onRequestError = useCallback((error: AxiosError) => {
    toast({
      tone: 'destructive',
      title: 'Error',
      description: error.message,
    });
  }, []);

  return useQueryDocumentTemplatesCore(
    isAuthenticated && enabled,
    isDesktopOnlineReady,
    onRequestError
  );
}
